import { AreaChart, Area, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { fmtCompact } from "@/lib/format";

function Mini({ id, title, data, color = "brand-primary" }) {
  const stroke = color === "brand-secondary" ? "hsl(var(--brand-secondary))" : "hsl(var(--brand-primary))";
  const last = data?.length ? data[data.length - 1].value : 0;
  const total = data?.reduce((a, b) => a + b.value, 0) || 0;
  return (
    <div className="rounded-2xl border border-border/60 bg-card p-4 shadow-sm">
      <div className="flex items-baseline justify-between">
        <p className="text-sm font-semibold text-muted-foreground">{title}</p>
        <p className="font-heading text-lg font-bold">{fmtCompact(title === "Followers" ? last : total)}</p>
      </div>
      <div className="mt-2 h-[64px] w-full">
        <ResponsiveContainer width="100%" height={64} minWidth={0}>
          <AreaChart data={data} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={stroke} stopOpacity={0.35} />
                <stop offset="100%" stopColor={stroke} stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" hide />
            <Tooltip
              contentStyle={{ borderRadius: 12, border: "1px solid hsl(var(--border))", fontSize: 12 }}
              labelFormatter={(l) => new Date(l).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
              formatter={(v) => [fmtCompact(v), title]}
            />
            <Area type="monotone" dataKey="value" stroke={stroke} strokeWidth={2} fill={`url(#${id})`} dot={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default function Trends({ trends }) {
  if (!trends) return null;
  const items = [
    { key: "followers", title: "Followers" },
    { key: "reach", title: "Reach" },
    { key: "impressions", title: "Impressions" },
    { key: "engagement", title: "Engagement" },
    { key: "users", title: "Website Users", color: "brand-secondary" },
    { key: "sessions", title: "Sessions", color: "brand-secondary" },
  ];
  return (
    <section data-testid="trends-section">
      <h2 className="mb-4 font-heading text-2xl font-bold tracking-tight">Performance Trends</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((it) => (
          <Mini key={it.key} id={`trend-${it.key}`} title={it.title} data={trends[it.key]} color={it.color} />
        ))}
      </div>
    </section>
  );
}
